import type { PagesConfig } from '#types/config/pages'

export default {
  brandClasses: {
    submitButton: 'w-full md:max-w-72'
  },
  gender: {
    options: [
      { value: 'M', label: 'male' },
      { value: 'F', label: 'female' },
      { value: 'NA', label: 'preferNotToAnswer' }
    ],
    requiredLocales: [
      'da-dk',
      'en-gb',
      'en-dk',
      'es-es',
      'en-ie',
      'it-it',
      'fr-fr',
      'de-de',
      'de-at',
      'de-be',
      'fr-be',
      'nl-be',
      'en-se',
      'de-ch',
      'en-ch',
      'fr-ch',
      'it-ch',
      'de-lu',
      'fr-lu',
      'nl-lu',
      'nl-nl',
      'pt-pt',
      'sv-se'
    ]
  },
  newsletters: [{
    type: 'newsletter'
  }, {
    type: 'loyaltyNewsletter',
    onlyForLoyaltyMember: true,
    requiredLocales: [
      'en-gb',
      'it-it',
      'fr-fr',
      'de-de',
      'es-es',
      'nl-nl'
    ]
  }],
  interestOnlyForSubscription: {
    requiredLocales: [
      'da-dk',
      'en-gb',
      'en-dk',
      'es-es',
      'en-ie',
      'it-it',
      'fr-fr',
      'de-de',
      'de-at',
      'de-be',
      'fr-be',
      'nl-be',
      'en-se',
      'de-ch',
      'en-ch',
      'fr-ch',
      'it-ch',
      'de-lu',
      'fr-lu',
      'nl-lu',
      'nl-nl',
      'pt-pt',
      'sv-se'
    ]
  }
} satisfies PagesConfig['profile']
